module.exports = __webpack_public_path__ + "static/media/dad.675f9ef0.png";